module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[116]115.451929f.woff2";